import styled from 'styled-components'

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 500px;
`

export const ImageContainer = styled.div`
  margin: 2rem 0;
  display: flex;
  justify-content: center;
  width: 100%;

  img {
    max-width: 100%;
    height: auto;
  }
`

export const InstructionText = styled.p`
  text-align: left;
  max-width: 500px;
  line-height: 1.5rem;
  margin: 0;
`

export const FirstInstruction = styled(InstructionText)`
 text-align: left;
  margin-bottom: 1.5rem;
`

export const SecondInstruction = styled(InstructionText)`
  margin-bottom: 2rem;
`

export const ButtonContainer = styled.div`
  margin-top: 2.8rem;
  width: 100%;
  display: flex;
  justify-content: center;
`

